// extracted by mini-css-extract-plugin
export default {"tooltipContent":"TooltipNew_tooltipContent__WWWnW","tooltipContentInner":"TooltipNew_tooltipContentInner__hPsvc","arrow":"TooltipNew_arrow__n+I8V"};